export const ON_GET_DASHBOARD_DATA_REQUEST = 'ON_GET_DASHBOARD_DATA_REQUEST';
export const ON_GET_DASHBOARD_DATA_SUCCESS = 'ON_GET_DASHBOARD_DATA_SUCCESS';
export const ON_GET_DASHBOARD_DATA_FAILED = 'ON_GET_DASHBOARD_DATA_FAILED';
